import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

/**
 * Renders the server-produced `changes_html` of a release feed entry.
 *
 * The HTML is authored only by internal staff in Strapi admin and produced by
 * the trusted server-side `blocksToHtml()` util, so the XSS surface is low. No
 * DOMPurify sanitizer exists in the repo; we render through react-markdown +
 * rehype-raw (which parses to a controlled AST) rather than a bare
 * `dangerouslySetInnerHTML`.
 *
 * `@tailwindcss/typography` (the `prose` class) is NOT installed, so list
 * markers / spacing are styled explicitly via the `.release-changes` rules in
 * index.css (disc top tier, circle nested). We use react-markdown's default
 * element renderers (no `components` override) so the internal `node` prop never
 * leaks onto the DOM.
 */
const ReleaseChanges = ({ html }: { html: string }) => {
  if (!html) return null;

  return (
    <div className="release-changes max-w-full break-words text-gray-700">
      <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
        {html}
      </ReactMarkdown>
    </div>
  );
};

export default ReleaseChanges;
